<template>
    <div>
        <section class="hero-area">
            <div class="hero-slider">

                <div class="hero-inner overlay" style="background-image: url('/assets/img/hero/slide6.png');">
                    <div class="container">
                        <div class="row ">
                            <div class="col-lg-8 offset-lg-2 col-md-12 co-12">
                                <div class="home-slider">
                                    <div class="hero-text">
                                        <h1 class="wow fadeInUp" data-wow-delay=".5s">Welcome To The <br> <span>Tribe Of
                                                Innovation</span>
                                        </h1>
                                        <p class="wow fadeInUp" data-wow-delay=".7s">Be a part of the Next Generation
                                            Research, Start Up and Scalable Enterprises, Built for Africa
                                        </p>
                                        <div class="button wow fadeInUp" data-wow-delay=".9s">
                                            <a href="https://app.tribinnovafrica.com/register?type=investor"
                                                target="blank" class="btn">Join The Investment Tribe
                                             </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="hero-inner overlay" style="background-image: url('/assets/img/hero/slide2.png');">
                    <div class="container">
                        <div class="row ">
                            <div class="col-lg-8 offset-lg-2 col-md-12 co-12">
                                <div class="home-slider">
                                    <div class="hero-text">
                                        <h1 class="wow fadeInUp" data-wow-delay=".5s">Make Your<br> <span>Your Next
                                                Generation</span>
                                            <br> Beam With Smile
                                        </h1>
                                        <p class="wow fadeInUp" data-wow-delay=".7s">Take opportunities today to build
                                            and own legacies, that you pass down to children.
                                        </p>
                                        <div class="button wow fadeInUp" data-wow-delay=".9s">
                                            <router-link to="/about" class="btn">Learn More</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="hero-inner overlay" style="background-image: url('/assets/img/hero/slide1.png');">
                    <div class="container">
                        <div class="row ">
                            <div class="col-lg-8 offset-lg-2 col-md-12 co-12">
                                <div class="home-slider">
                                    <div class="hero-text">
                                        <h1 class="wow fadeInUp" data-wow-delay=".5s">We Are Using<br> <span>4IR
                                                technologies</span>
                                            <br> To Solve Africa's Problem
                                        </h1>
                                        <p class="wow fadeInUp" data-wow-delay=".7s">Got some Tech Skills? Are you a
                                            Junior, Intermediate, or Senior? Join our Community!
                                        </p>
                                        <div class="button wow fadeInUp" data-wow-delay=".9s">
                                            <a href="https://app.tribinnovafrica.com/register?type=talent"
                                                target="blank" class="btn">Join Talents Hub</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="hero-inner overlay" style="background-image: url('/assets/img/hero/slide7.png');">
                    <div class="container">
                        <div class="row ">
                            <div class="col-lg-8 offset-lg-2 col-md-12 co-12">
                                <div class="home-slider">
                                    <div class="hero-text">
                                        <h1 class="wow fadeInUp" data-wow-delay=".5s">This Is A Tribe <br>
                                            <span> For Africa</span>, <br> Build With Us
                                        </h1>
                                        <p class="wow fadeInUp" data-wow-delay=".7s">The wealth of Africa is in her
                                            people. We are building her economy, Don’t Miss Out!
                                        </p>
                                        <div class="button wow fadeInUp" data-wow-delay=".9s">
                                            <a href="https://app.tribinnovafrica.com/register?type=company"
                                                target="blank" class="btn">Register Your Company</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="hero-inner overlay" style="background-image: url('/assets/img/hero/slide5.png');">
                    <div class="container">
                        <div class="row ">
                            <div class="col-lg-8 offset-lg-2 col-md-12 co-12">
                                <div class="home-slider">
                                    <div class="hero-text">
                                        <h1 class="wow fadeInUp" data-wow-delay=".5s">We Focus On <br> <span>Research,
                                                Innovation and Industry.</span>
                                        </h1>
                                        <p class="wow fadeInUp" data-wow-delay=".7s">Have you been interested in
                                            manufacturing, energy, storage and many more? Come in now!.
                                        </p>
                                        <div class="button wow fadeInUp" data-wow-delay=".9s">
                                            <div class="button wow fadeInUp" data-wow-delay=".9s">
                                                <a href="https://app.tribinnovafrica.com/register" target="blank"
                                                    class="btn">Create An Account</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="hero-inner overlay" style="background-image: url('/assets/img/hero/slide4.png');">
                    <div class="container">
                        <div class="row ">
                            <div class="col-lg-8 offset-lg-2 col-md-12 co-12">
                                <div class="home-slider">
                                    <div class="hero-text">
                                        <h1 class="wow fadeInUp" data-wow-delay=".5s">Be Part Of <br><span>The Future
                                            </span><br> While It Is Young
                                        </h1>
                                        <p class="wow fadeInUp" data-wow-delay=".7s">Fund great businesses of the
                                            future, even while they are just being conceived
                                        </p>
                                        <div class="button wow fadeInUp" data-wow-delay=".9s">
                                            <a href="https://app.tribinnovafrica.com/register?type=investor"
                                                target="blank" class="btn">Register As An Investor</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
    <!-- Carousel End -->
</template>

<script>
    export default {
        name: 'Carousel'
    }
</script>
